import { createDebugger } from '~/scripts/utils/debug.js';

const debug = createDebugger('filter-drawer', false);

let _wasOpen = false;

class FilterDrawer {
  constructor() {
    this.el = document.querySelector('[data-filter-drawer]');
    if (!this.el) return;

    this._onKeydown = this._onKeydown.bind(this);
    this._bindEvents();
    this._stubLegacyDrawer();

    debug.log('initialized');
  }

  get isOpen() {
    return this.el.hasAttribute('open');
  }

  open() {
    _wasOpen = true;
    this.el.setAttribute('open', '');
    document.documentElement.classList.add('js-filter-drawer-open');
  }

  close() {
    _wasOpen = false;
    this.el.removeAttribute('open');
    document.documentElement.classList.remove('js-filter-drawer-open');
  }

  // Restore open state after AJAX re-renders the DOM, without playing the slide-in animation
  restoreOpen() {
    this.el.classList.add('filter-drawer--instant');
    this.el.setAttribute('open', '');
    document.documentElement.classList.add('js-filter-drawer-open');
    requestAnimationFrame(() => requestAnimationFrame(() => {
      this.el.classList.remove('filter-drawer--instant');
    }));
  }

  destroy() {
    document.removeEventListener('keydown', this._onKeydown);
  }

  _bindEvents() {
    document.querySelectorAll('[data-filter-drawer-open]').forEach(btn => {
      btn.addEventListener('click', () => this.open());
    });

    this.el.querySelectorAll('[data-filter-drawer-close]').forEach(el => {
      el.addEventListener('click', () => this.close());
    });

    document.addEventListener('keydown', this._onKeydown);
  }

  _onKeydown(e) {
    if (e.key === 'Escape' && this.isOpen) this.close();
  }

  // Stub theme.FilterDrawer so legacy close() calls are no-ops -
  // we manage drawer state ourselves and don't want it closing on filter changes
  _stubLegacyDrawer() {
    if (!window.theme) return;
    window.theme.FilterDrawer = {
      open: () => this.open(),
      close: () => {},
      isOpen: false,
    };
  }
}

let instance = null;

function init() {
  if (instance) instance.destroy();
  instance = new FilterDrawer();
}

document.addEventListener('DOMContentLoaded', init);

document.addEventListener('collection:reloaded', () => {
  const wasOpen = _wasOpen;
  init(); // destroy old instance (removes keydown listener), create new one
  if (wasOpen) {
    instance?.restoreOpen();
  }
});
